<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import { resolveMathConditionSummary } from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: expression = String(data.expression || data.sceneData?._gui_math_expression || '').trim();
	$: parameterCount = Array.isArray(data.params)
		? data.params.length
		: Array.isArray(data.sceneData?._gui_math_params)
			? data.sceneData._gui_math_params.length
			: 0;
	$: summary = resolveMathConditionSummary(data);
</script>

<BaseConditionNode
	{id}
	type="mathCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={summary}
	nodeTypeLabel="Math expression"
	{...$$restProps}
>
	<div class="math-body">
		<div class="sentence">
			<span class="keyword">When</span>
			<span class:placeholder={!expression} class="expression">
				{expression || 'Configure an expression'}
			</span>
		</div>
		<div class="meta">
			<i class="fa fa-square-root-variable" aria-hidden="true" />
			{parameterCount}
			{parameterCount === 1 ? 'parameter' : 'parameters'}
		</div>
	</div>
</BaseConditionNode>

<style>
	.math-body {
		display: grid;
		gap: 0.45rem;
		padding: 0.55rem;
	}
	.sentence {
		color: var(--flow-slot-soft, #334155);
		font-size: 0.875rem;
		line-height: 1.4;
	}
	.keyword {
		color: #c4b5fd;
		font-weight: 700;
		margin-right: 0.3rem;
	}
	.expression {
		color: var(--flow-slot-strong, #111827);
		font-weight: 650;
		overflow-wrap: anywhere;
	}
	.expression.placeholder {
		color: var(--flow-slot-muted, #64748b);
		font-weight: 500;
	}
	.meta {
		display: flex;
		align-items: center;
		gap: 0.35rem;
		color: #a78bfa;
		font-size: 0.72rem;
	}
</style>
